import React, {Component} from 'react';

import SimpleLineChart from './SimpleLineChart';
import SimpleAreaChart from './SimpleAreaChart';
import SimpleBarChart from './SimpleBarChart';
import SimplePieChart from './SimplePieChart';
import '../../../scss/charts.scss';

class Charts extends React.Component {
    constructor(props) {
        super(props);
        this.coefficients = {
            WIDTH: 0.8,
            HEIGHT: 0.5,
            PIE_CHART_HEIGHT: 1.3,
            PIE_CHART_RADIUS: 3.5,
        };

        this.state = {
            width: window.innerWidth * this.coefficients.WIDTH,
            height: window.innerHeight * this.coefficients.HEIGHT,
        };
    }

    /**
     * Calculate & Update state of new dimensions
     */
    updateDimensions() {
        if(!this.chartsContainer
            || (this.state.width === this.chartsContainer.offsetWidth && this.state.height === window.innerHeight * this.coefficients.HEIGHT)
        ) {
            return;
        }

        this.setState({
            width: this.chartsContainer.offsetWidth,
            height: window.innerHeight * this.coefficients.HEIGHT,
        });
    }

    prepareData() {
        let {
            data,
            dataKeyName,
            dataValueName,
        } = this.props;

        if(data instanceof Array) {
            return data.slice();
        }

        data = {...data};
        const multipleData = {};

        Object.keys(data).forEach(contextName => {
            data[contextName].forEach(contextData => {
                const keyName = contextData[dataKeyName];
                if(!multipleData[keyName]) {
                    multipleData[keyName] = {};
                }

                multipleData[keyName][contextName] = contextData[dataValueName];
            });
        });

        return Object.keys(multipleData).map(key => {
            multipleData[key].key = key;
            return multipleData[key]
        });
    }



    renderChart(type) {
        let {
            chartTypes = ['line'],
            lineKeys,
            statisticsIsEmpty,
        } = this.props;

        const data = this.prepareData();


        switch (type) {
            case 'line':
                return chartTypes.indexOf(type) !== -1 ?
                    <div className="row">
                        {statisticsIsEmpty && <h1 className="noanalytics-linechart-alert" style={{fontSize: `${this.state.width / 37}px`}}>Statistik af valgte interval er tom</h1>}
                        <SimpleLineChart
                            data={data}
                            width={this.state.width}
                            height={this.state.height}
                            lineKeys={lineKeys}
                        />
                    </div>
                    : null;
            case 'area':
                return chartTypes.indexOf(type) !== -1 ?
                    <div className="row mb-4">
                        <SimpleAreaChart
                            data={data}
                            width={this.state.width}
                            height={this.state.height}
                        />
                    </div>
                    : null;
            case 'bar':
                return chartTypes.indexOf(type) !== -1 ?
                    <div className="row">
                        <SimpleBarChart
                            data={data}
                            width={this.state.width}
                            height={this.state.height}
                        />
                    </div>
                    : null;
            case 'pie':
                return chartTypes.indexOf(type) !== -1 ?
                    <div className="row">
                        <SimplePieChart
                            data={data}
                            width={this.state.width}
                            height={this.state.width/this.coefficients.PIE_CHART_HEIGHT}
                            outerRadius={this.state.width/this.coefficients.PIE_CHART_RADIUS}
                        />
                    </div>
                    : null;
            default:
                return null;

        }
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-12" ref={(container) => this.chartsContainer = container}>
                        {this.renderChart('line')}
                        {this.renderChart('area')}
                        {this.renderChart('bar')}
                        {this.renderChart('pie')}
                    </div>
                </div>
            </div>
        );
    }

    /**
     * Add event listener
     */
    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }
}

Charts.defaultProps = {
    dataKeyName: 'key',
    dataValueName: 'value',
};

export default Charts;


// WEBPACK FOOTER //
// ./web/src/components/charts/Charts.jsx